module.exports = __webpack_public_path__ + "static/media/loader.69d95592.gif";